import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function ProblemSection() {
  const fadeIn = useFadeIn();
  return <section className="py-10 md:py-16 px-4 bg-black text-white border-y-8 border-red-600" data-id="element-211">
      <div className="max-w-3xl mx-auto" data-id="element-212">
        <div ref={fadeIn.ref} className={`space-y-6 md:space-y-8 text-base md:text-xl ${fadeIn.className}`} data-id="element-213">
          <div className="text-center mb-8 md:mb-12" data-id="element-214">
            <h2 className="text-2xl md:text-4xl font-black text-yellow-400 mb-4 md:mb-6" data-id="element-215">
              💔 Do Any Of These Sound Familiar?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-216">
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-217">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-218">📱</div>
              <p className="text-gray-300 font-medium" data-id="element-219">
                Screens are the only thing that keeps them calm — and that guilt
                never goes away.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-220">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-221">🥱</div>
              <p className="text-gray-300 font-medium" data-id="element-222">
                You buy activity books that last three days and end up
                forgotten.
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-223">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-224">😤</div>
              <p className="text-gray-300 font-medium" data-id="element-225">
                Every homework session ends in tears, arguments or "I can't do
                this."
              </p>
            </div>
            <div className="bg-gray-900 p-5 md:p-6 rounded-xl border border-gray-700 shadow-lg" data-id="element-226">
              <div className="text-3xl md:text-4xl mb-3 md:mb-4" data-id="element-227">⏳</div>
              <p className="text-gray-300 font-medium" data-id="element-228">
                You can see your child is smart — but they can't show it because
                they lose focus before finishing.
              </p>
            </div>
          </div>

          <div className="text-center mt-8 md:mt-12 space-y-3 md:space-y-4" data-id="element-229">
            <p className="text-xl md:text-2xl font-bold text-white" data-id="element-230">
              It's not a lack of effort. It's that nobody taught their brain how
              to work.
            </p>
            <p className="text-xl md:text-2xl font-bold text-yellow-400" data-id="element-231">
              School teaches children WHAT to think. Nobody teaches them HOW to
              think.
            </p>
            <p className="text-gray-300 max-w-2xl mx-auto mt-3 md:mt-4" data-id="element-232">
              That gap shows up every single day — in the frustration, the
              meltdowns, the "I give up," and the endless screen battles.
            </p>
          </div>

          <div className="bg-gray-900 p-6 md:p-8 rounded-xl border border-yellow-500 mt-8 md:mt-12 shadow-2xl" data-id="element-233">
            <div className="space-y-4 md:space-y-6 text-gray-300" data-id="element-234">
              <p className="flex items-start gap-3" data-id="element-235">
                <span className="text-xl md:text-2xl" data-id="element-236">🔑</span>
                <span className="font-bold text-white" data-id="element-237">
                  What your child needs isn't more content. They need a system
                  that trains their brain progressively — area by area — until
                  everything works together.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-238">
                <span className="text-xl md:text-2xl" data-id="element-239">🧠</span>
                <span data-id="element-240">
                  The Little Genius System™ gives you 310 pages of short,
                  powerful brain-building activities designed to activate the 5
                  core areas of the brain and develop real cognitive skills.
                </span>
              </p>
              <p className="flex items-start gap-3" data-id="element-241">
                <span className="text-xl md:text-2xl" data-id="element-242">✨</span>
                <span className="font-bold text-yellow-400" data-id="element-243">
                  What if this week was the turning point where your child
                  finally showed everything they're truly capable of?
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}